import { createSelector } from 'reselect'

export const getLogo = createSelector(
  state => state && state.user && state.user.registration && state.user.registration.logo
    ? state.user.registration.logo : null,
  logo => logo
)
